import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const AppLiveEventBoundary = () => import(/* webpackChunkName: "4-page-app-live-event" */ './AppLiveEventBoundary');

const LoadableAppLiveEvent = lazyLoadOnRender({ loader: AppLiveEventBoundary });

export default LoadableAppLiveEvent;
